import { BACKEND_URL_PREFIX } from '../assets/const';
import { createNotification } from '../components/Notifications/Notifications';
import { buildDefaultHeaders } from './helper';
import { getError } from '../utils/getError';
import {
  SET_SITES,
  SET_SITES_LOADING,
  SET_SITES_PAGE,
  SET_SITE,
  SET_SITE_LOADING,
} from './types';

export const setPage = (pageNumber) => ({
  type: SET_SITES_PAGE,
  payload: {
    pageNumber: pageNumber,
  },
});

export const getSites = () => async (dispatch, getState) => {
  dispatch({ type: SET_SITES_LOADING, payload: true });

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/site`, {
      method: 'GET',
      ...buildDefaultHeaders(getState),
    });

    getError({ response, dispatch });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_SITES, payload: data });
    } else {
      const err = await response.json();
      createNotification('error', err?.msg || 'Ошибка');
      dispatch({ type: SET_SITES, payload: [] });
    }
  } catch (error) {
    createNotification('error', 'Ошибка сети при загрузке');
  } finally {
    dispatch({ type: SET_SITES_LOADING, payload: false });
  }
};

export const getSite = (id) => async (dispatch, getState) => {
  dispatch({ type: SET_SITE_LOADING, payload: true });

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/site/${id}`, {
      method: 'GET',
      ...buildDefaultHeaders(getState),
    });

    getError({ response, dispatch });

    const data = await response.json();
    dispatch({ type: SET_SITE, payload: data });
  } catch (error) {
    createNotification('error', 'Ошибка при получении данных сайта');
  } finally {
    dispatch({ type: SET_SITE_LOADING, payload: false });
  }
};

export const createSite = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_SITE_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/site`, {
      method: 'POST',
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    });
    
    getError({ response, dispatch });

    if (response.ok) {
      createNotification('success', 'Успешно');
    } else {
      createNotification('error', 'Ошибка');
    }
  } catch (error) {
    createNotification('error', 'Ошибка');
  } finally {
    await dispatch(getSites());
  }
  dispatch({ type: SET_SITE_LOADING, payload: false });
};

export const updateSite = (id, data) => async (dispatch, getState) => {
  dispatch({ type: SET_SITES_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/site/${id}`, {
      method: 'PUT',
      headers: {
        ...buildDefaultHeaders(getState).headers,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (response.ok) {
      getError({ response, dispatch });
      createNotification('success', 'Данные обновлены!');
      return { success: true, user: result };
    } else {
      createNotification('error', result?.error || 'Ошибка обновления');
      return { success: false };
    }
  } catch (error) {
    createNotification('error', 'Ошибка сети при обновлении пользователя');
    return { success: false };
  } finally {
    dispatch(getSites());
    dispatch({ type: SET_SITES_LOADING, payload: false });
  }
};

export const deleteSite = (id) => async (dispatch, getState) => {
  if (getState().auth.token) {
    dispatch({ type: SET_SITE_LOADING, payload: true });
    try {
      const response = await fetch(`${BACKEND_URL_PREFIX}/site/${id}`, {
        method: 'DELETE',
        ...buildDefaultHeaders(getState),
      });
      if (response.ok) {
        getError({ response, dispatch });
        createNotification('success', 'Успешно');
      } else {
        createNotification('error', 'Ошибка');
      }
    } catch (error) {
      createNotification('error', 'Ошибка');
    } finally {
      await dispatch(getSites());
    }
  }
  dispatch({ type: SET_SITE_LOADING, payload: false });
};
